import { convertTo12hTime } from './time-entry-modifications-util'
import templateUrl from './time-entry-modifications.component.html'
import './time-entry-modifications.component.less'

export const DashboardTimeEntryModificationsComponent = {
    bindings: {
        timeEntryModifications: "<"
    },
    templateUrl,
    controllerAs: "vm",
    controller: class TimeEntryModifications {
        constructor() {
            'ngInject'
            this.pageSize = 10;
            this.pageNumber = 1;
        }

        $onChanges(changesObj) {
            if (changesObj.timeEntryModifications) {
                convertTo12hTime(this.timeEntryModifications)
            }
        }
    }
}
